import Icon from '../components/Icon.vue'

Icon.register({
  pause: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M144 479h-96c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM448 431c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352z'
      }
    ]
  }
})
